import { render, staticRenderFns } from "./modalConsolidadoProductosReparto.vue?vue&type=template&id=0137c057&"
import script from "./modalConsolidadoProductosReparto.vue?vue&type=script&lang=js&"
export * from "./modalConsolidadoProductosReparto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports